import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

const { t } = i18n.global

export const CustomerGroupPages = {
  list: 'ListCustomerGroup',
  add: 'AddCustomerGroup',
  edit: 'EditCustomerGroup',
}

const title = t('pages.customerGroups')
const path = '/customer-groups'
const breadcrumb = [{ title, path }]

const Add: RouteRecordRaw = {
  path: 'add',
  name: CustomerGroupPages.add,
  component: () => import('@/pages/mainPageWithRoute/customer-group/AddCustomerGroupPage.vue'),
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: CustomerGroupPages.edit,
  component: () => import('@/pages/mainPageWithRoute/customer-group/EditCustomerGroupPage.vue'),
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: CustomerGroupPages.list,
  component: () => import('@/pages/mainPageWithRoute/customer-group/ListCustomerGroupPage.vue'),
  meta: { title, requiresAuth: true },
}

export const CustomerGroups: RouteRecordRaw = {
  path,
  name: t('pages.customerGroups'),
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
